import { Connection } from "@solana/web3.js"

export const RPC_ENDPOINT = "https://mainnet.helius-rpc.com/?api-key=c9018c54-1f79-4563-9915-3768ffef0b14"

export const connection = new Connection(RPC_ENDPOINT, "processed")
